// RAISE-19075: PMO / Atlassian-suite admin surfaces. Build-time (Vite inlines it).
// Default ON - only an explicit "false" hides. Read at call time so tests can vi.stubEnv.
export function isPmoFeatureEnabled(): boolean {
  const raw = import.meta.env.VITE_FEATURE_PMO as string | undefined;
  return raw?.trim().toLowerCase() !== "false";
}
